import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  events: Yup.array().min(1, 'Campo obrigatório').required('Campo obrigatório'),
});
